import './HomeOfficeTypeSelection.scss'
import { Dropdown } from 'primereact/dropdown'
import OptionIcon from '../../assets/icons/options.png'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'

const HomeOfficeTypeSelection = (props: { selectedType: any; setSelectedType: any; types: any[] }) => {
  const { t } = useTranslation()
  return (
    <div className="homeoffice-type-container">
      {props.selectedType !== null && (
        <label className="autocomplete-title">{t('input-texts.remote-office-type')}</label>
      )}
      <i className="autocomplete-icon p-input-icon-left">
        <img src={OptionIcon} width="30px" alt="logo" />
      </i>
      {props.types.length > 1 && (
        <Dropdown
          value={props.selectedType}
          optionLabel={i18next.language === 'tr' ? 'displayedText' : 'en'}
          className="homeoffice-autocomplete"
          dropdownIcon={props.types.length <= 1 ? '' : 'pi pi-angle-down'}
          options={props.types}
          onChange={(e) => props.setSelectedType(e.target.value)}
          // disabled={props.types.length === 1}
        />
      )}
      {props.types.length === 1 && (
        <div className="homeoffice-autocomplete homeoffice-autocomplete-one">
          {i18next.language === 'tr' ? props.types[0].displayedText : props.types[0].en}
        </div>
      )}
    </div>
  )
}

export default HomeOfficeTypeSelection
